/**
 * File name for a downloaded warranty certificate: the server names it
 * (WC-<year>-<id>.pdf) in Content-Disposition; use that, else the old generic name.
 */
export function certificateFileName(contentDisposition: unknown): string {
  const m = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(String(contentDisposition ?? ''));
  const raw = m?.[1]?.trim();
  if (!raw) return 'warranty-certificate.pdf';
  try {
    const name = decodeURIComponent(raw).replace(/[\\/]/g, '_');
    return name || 'warranty-certificate.pdf';
  } catch {
    return 'warranty-certificate.pdf';
  }
}
